import { Component } from '@angular/core';
import { header } from './config/surgeries-assigned.config';

import { SurgeryService } from '../../services/surgery/surgery.service';
import { privateheader } from './config/surgeries-assigned-private.config';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-surgeries-assigned',
  templateUrl: './surgeries-assigned.component.html',
  styleUrl: './surgeries-assigned.component.scss',
})
export class SurgeriesAssignedComponent {
  constructor(
    private surgeryService: SurgeryService,
    private authservice: AuthService
  ) {}

  ngOnInit() {
    this.surgeryService.init();
  }

  getPageHeader(): string {
    if (this.authservice.hasRoles(['ViewOnly'])) {
      return 'Λίστα Χειρουργείων';
    }
    return this.authservice.hasRoles([
      'PrivateHospitalAdmin',
      'PrivateClinicAdmin',
    ])
      ? privateheader
      : header;
  }
}
